function compareVersions(v1, v2) {
    const parts1 = v1.split('.').map(Number);
    const parts2 = v2.split('.').map(Number);
    const maxLen = Math.max(parts1.length, parts2.length);
    for (let i = 0; i < maxLen; i++) {
        const num1 = parts1[i] || 0;
        const num2 = parts2[i] || 0;
        if (num1 > num2) return 1;
        if (num1 < num2) return -1;
    }
    return 0;
}

function shouldShowOptimizeMySystem() {
    const clientVersion = window.sessionStorage.getItem("clientVersion");
    if (!clientVersion) return false;
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (isFirefox) return false;
    return compareVersions(clientVersion, "10.0.73.0") >= 0;
}

(function initOptimizeMySystemVisibility() {
    const optimizeBtn = document.querySelector('#divQuickActions .prompt-button[data-key="Optimize_my_system"]');
    if (optimizeBtn) {
        if (shouldShowOptimizeMySystem()) {
            optimizeBtn.style.display = '';
        } else {
            optimizeBtn.remove();
        }
    }
})();
const dellMetricsTrackProp20 = (appcode, tabname) => {
    try {
        if (typeof (window.dellmetricsTrack) === "function") {
            if (window.dellmetricsTrack) {
                window.dellmetricsTrack(appcode, tabname);
            }
        }
    } catch (ex) {
        console.error(`${ex}`);
    }
}

const signInBtn = document.getElementById('signInBtn');
if (signInBtn != null) {
    signInBtn.addEventListener("click", function () {
        dellMetricsTrackProp20('222.900.100.250', 'home|signin');
    });
}

const visitCorpBusinessLink = document.getElementById('businessvisitlink');
if (visitCorpBusinessLink != null) {
    visitCorpBusinessLink.addEventListener("click", function () {
        dellMetricsTrackProp20('222.900.200.101', 'home|visitbusinesssite');
    });
}

function updateSendButtonState() {
    const inputEl = document.getElementById('txtChatBoxInput');
    const sendBtn = document.getElementById('btnChatBoxSend');
    if (inputEl && sendBtn) {
        const hasText = inputEl.value.trim().length > 0;
        sendBtn.disabled = !hasText;
        sendBtn.style.cursor = hasText ? 'pointer' : 'not-allowed';
        sendBtn.style.opacity = hasText ? '1' : '0.35';
    }
}

const SEND_ICON_ARROW = 'dds__icon--arrow-right';
const SEND_ICON_STOP = 'dds__icon--stop';

function setSendButtonLoading(isLoading) {
    const sendBtn = document.getElementById('btnChatBoxSend');
    if (!sendBtn) {
        return;
    }
    if (isLoading) {
        sendBtn.disabled = false;
        sendBtn.style.cursor = 'pointer';
        sendBtn.style.opacity = '1';
    }
    sendBtn.classList.toggle(SEND_ICON_ARROW, !isLoading);
    sendBtn.classList.toggle(SEND_ICON_STOP, isLoading);
    if (!isLoading) {
        updateSendButtonState();
    }
}

const chatBoxSend = document.getElementById('btnChatBoxSend');
if (chatBoxSend != null) {
    chatBoxSend.addEventListener("click", async function () {
        if (document.getElementById("txtChatBoxInput").value.trim() == "") {
            document.getElementById("txtChatBoxInput").value = "";
            return;
        }
        const targetUrl = await fetchproductdata(document.getElementById("txtChatBoxInput").value);
        if (targetUrl != null) {
            setSendButtonLoading(true);
            if (typeof (Storage) !== "undefined") {
                window.sessionStorage.setItem("micromomentsCoBrowse", "True");
            }
            window.location.href = targetUrl;
        }
        else {
            dellMetricsTrackProp20('', 'UnifiedChat|questionentered|send|IFD');
            const inputEl = document.getElementById('txtChatBoxInput');
            const value = inputEl ? inputEl.value : '';

            const tabname = value.trim();
            if (tabname) {
                Dell.Metrics.sc.searchTerm = "IFDhomepage|" + tabname;
                dellMetricsTrackProp20('222.930.100.001', 'home|' + tabname);
            }
            submitVaEvent(value);

            if (inputEl) {
                inputEl.value = '';
                updateSendButtonState();
            }
        }

    });
}

var micButton = document.getElementById("voiceButton");
var micButtonText = document.getElementById("voiceButtonText");
var textarea = document.getElementById("txtChatBoxInput");

// Voice recognition setup
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
if (SpeechRecognition) {
    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = 'en-US'; // To Do: Check 

    micButton.addEventListener("click", () => {
        recognition.start();
        micButtonText.innerText = "";
        micButtonText.insertAdjacentHTML('beforeend', `<div id="voiceSpinner" class="dds__loading-indicator__spinner"></div>`);
    });

    recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        textarea.value += transcript + " ";
        updateSendButtonState();
        document.getElementById("voiceSpinner")?.remove();
    };

    recognition.onerror = (event) => {
        console.log("Speech recognition error: " + event.error);
        document.getElementById("voiceSpinner")?.remove();
    };

    recognition.onend = () => {
        document.getElementById("voiceSpinner")?.remove();
    };
} else {
    micButton.disabled = true;
}


const chatBoxInput = document.getElementById('txtChatBoxInput');
if (chatBoxInput != null) {
    updateSendButtonState();
    chatBoxInput.addEventListener('input', updateSendButtonState);

    chatBoxInput.addEventListener("keydown", async function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (document.getElementById("txtChatBoxInput").value.trim() == "") {
                document.getElementById("txtChatBoxInput").value = "";
                return;
            }
            const targetUrl = await fetchproductdata(document.getElementById("txtChatBoxInput").value);
            if (targetUrl != null) {
                setSendButtonLoading(true);
                if (typeof (Storage) !== "undefined") {
                    window.sessionStorage.setItem("micromomentsCoBrowse", "True");
                }
                window.location.href = targetUrl;
            }
            else {
                dellMetricsTrackProp20('', 'UnifiedChat|questionentered|send|IFD');             
                const inputEl = document.getElementById('txtChatBoxInput');
                const value = inputEl ? inputEl.value : '';

                const tabname = value.trim();
                if (tabname) {
                    Dell.Metrics.sc.searchTerm = "IFDhomepage|" + tabname;
                    dellMetricsTrackProp20('222.930.100.001', 'home|' + tabname);
                }
                submitVaEvent(value);

                if (inputEl) {
                    inputEl.value = '';
                    updateSendButtonState();
                }
            }
        }
    });
}
async function fetchproductdata(ServiceTag) {
    const trimmedTag = ServiceTag.trim();
    var appname = document.getElementById('hd-home-mfe-appname')?.dataset?.appname ?? 'home';
    if (/\s/.test(ServiceTag.trim())) return;
    var data = {
        Selection: trimmedTag,
        appName: appname,
        EnableAssetSearch: true,
        EnableSRSearch: false,
        EnableKeywordSearch: false,
        EnableSolutionIdSearch: false
    };
    const customHeader = new Headers();
    customHeader.append('Content-Type', 'application/json');
    customHeader.append('X-Requested-With', 'XMLHttpRequest');

    var hostname = "";
    if (window.location.hostname.indexOf("localhost") === 0) {
        hostname = "https://www-sit-g2.dell.com";
    }

    return window.fetch(`${hostname}/support/assetdiscovery/${Dell.Metrics.sc.language}-${Dell.Metrics.sc.country}/validate/asset`,
        {
            "method": "POST",
            headers: customHeader,
            body: JSON.stringify(data),
            credentials: 'include'
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status:${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            if (data !== null) {
                var productCode = "";
                var productName = "";
                var encryptData = "";
                var targetUrl = "";
                if (data !== null && data.lookupResults !== null && data.lookupResults.length > 0) {
                    targetUrl = data.lookupResults[0].targetUrl;
                }
                if (targetUrl != "") {
                    return targetUrl;
                }
            }
        })
        .catch(error => {
            document.getElementById("IFD-mfe-loading")?.remove();
        });
};

async function submitVaEvent(data) {
    window.dispatchEvent(
        new CustomEvent('va-chat-submit-ex', {
            detail: {
                source: "IFD",
                serviceDomain: "support",
                user_query: data // max length 200 characters
                //user_typed: true
            }
        }));
    document.getElementById("txtChatBoxInput").value = "";
};


document.querySelectorAll('#divQuickActions .prompt-button').forEach((item) => {
    item.addEventListener('click', async function (event) {
        const innerDiv = item.querySelector('.prompt-text');
        dellMetricsTrackProp20('222.930.100.002', 'home|' + innerDiv.textContent);
        const redirectUrl = item.getAttribute('data-redirectUrl');
        if (redirectUrl) {
            sessionStorage.setItem("micromomentsCoBrowse", "True");
            sessionStorage.setItem("micromomentsCoBrowseText", innerDiv.textContent);
            window.location.href = redirectUrl;
        } else {
            submitVaEvent(innerDiv.textContent);
        }
    })
});